import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';

import classNames from 'classnames';

import { RestaurantsGroup } from 'PMT/entities/restaurantsGroup';

export default class ChooseRestaurantsGroupView extends Component {

  static defaultProps = {
    level: 0
  };

  static propTypes = {
    restaurantsGroup: PropTypes.objectOf(RestaurantsGroup).isRequired,

    selectedRestaurantsGroup: PropTypes.objectOf(RestaurantsGroup).isRequired,

    level: PropTypes.number,

    onClick: PropTypes.func.isRequired
  };

  //
  // Renderers
  //

  renderSubList() {
    return this.props.restaurantsGroup.children.map((childrenRestaurantsGroup) => {
      return (
        <ChooseRestaurantsGroupView
          key={childrenRestaurantsGroup.id}
          restaurantsGroup={childrenRestaurantsGroup}
          selectedRestaurantsGroup={this.props.selectedRestaurantsGroup}
          level={this.props.level + 1}
          onClick={this.props.onClick}
        />
      );
    });
  }

  render() {
    const className = classNames('group_name', {
      current: this.props.restaurantsGroup.id === this.props.selectedRestaurantsGroup.id
    });

    return (
      <div
        className='choose_restaurants_group_view'
      >
        <div
          className={className}
          onClick={() => { this.props.onClick(this.props.restaurantsGroup); }}
        >
          {this.props.restaurantsGroup.name}
        </div>
        {this.renderSubList()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/components/header/components/ChooseRestaurantsGroupView.js